/** 04. WORKFLOW — 수집에서 보고서까지 6단계 */
export const WORKFLOW_STEPS = [
  { icon: 'step-collect', width: 152, height: 152, title: '01. 수집', sub: 'COLLECT' },
  { icon: 'step-parse', width: 152, height: 156, title: '02. 파싱', sub: 'PARSE' },
  { icon: 'step-store', width: 152, height: 152, title: '03. 저장', sub: 'STORE' },
  { icon: 'step-investigate', width: 152, height: 152, title: '04. 분석', sub: 'INVESTIGATE' },
  { icon: 'step-intelligence', width: 152, height: 152, title: '05. 인텔리전스', sub: 'INTELLIGENCE' },
  { icon: 'step-collaborate', width: 178, height: 152, title: '06. 협업/보고', sub: 'COLLABORATE' },
];

/**
 * 07. AUTOMATION — 자동화 수준의 변화.
 * 스크롤(또는 자동 재생)로 한 번에 하나씩 활성화된다. `id` 는 앵커용.
 */
export const AUTOMATION_STEPS = [
  { label: '현재', value: 30, desc: ['도구 자동화 30%', '분석가 수동 분석 70%'] },
  { label: '도입 후', value: 70, desc: ['자동 처리 목표 70%', '분석가는 검토·판단에 집중'] },
  { id: 'goal', label: '장기 목표', value: 90, desc: ['도구 내 분석 완성', '최신 기법 반영 시차 고려'] },
];

/** 08. FEATURES — 침해사고 대응의 새로운 기준 */
export const FEATURE_CARDS = [
  {
    icon: 'feature-pipeline',
    width: 176,
    title: '단일 파이프라인',
    desc: '수집→파싱→분석→인텔→협업→보고서 모두 한 제품에서 처리',
  },
  {
    icon: 'feature-loop',
    width: 176,
    title: '분석↔인텔 선순환',
    desc: '그리드 셀에서 IoC 즉석 등록 → 과거 사건 소급·전수 자동 매칭',
  },
  {
    icon: 'feature-deploy',
    width: 176,
    title: '유연한 배포',
    desc: 'SaaS·온프레미스 동시 지원, 자체 LLM·GeoIP로 폐쇄망까지 커버',
  },
  {
    icon: 'feature-collab',
    width: 200,
    title: '실시간 협업',
    desc: '타임라인·보고서 동시 편집, 원격 커서·감사로그·버전 복원',
  },
  {
    icon: 'feature-rbac',
    width: 176,
    title: '권한 거버넌스',
    desc: '기능 단위 RBAC + 기간 한정 공유 + 레코드 가림 전 경로 강제',
  },
  {
    icon: 'feature-verify',
    width: 176,
    title: '복구·심층 검증',
    desc: 'NTFS $MFT/$J/$LogFile/$SDS 교차 + Hex 뷰어 바이트 검증',
  },
  {
    icon: 'feature-speed',
    width: 176,
    title: '고속 파싱 엔진',
    desc: 'Rust 병렬화 — Registry 14.9x, Amcache 169.7x',
  },
  {
    icon: 'feature-knowledge',
    width: 176,
    title: '조직 지식 축적',
    desc: '케이스 단위 분석 기록·통계 위협 인텔리전스로 재사용',
  },
];
